import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavController } from '@ionic/angular';
import { SharedDataService } from 'src/app/services/shared-data.service';

@Component({
    selector: 'app-modal-header-dm',
    templateUrl: './modal-header-dm.component.html',
    styleUrls: ['./modal-header-dm.component.scss'],
})
export class ModalHeaderDmComponent implements OnInit {

    @Input() modalTitle: string;
    @Input() modalSubTitle: string;
    @Input() showEvacuation: boolean;

    @Output() closeModal = new EventEmitter<string>();
    headerColor;
    menuColor;
    subMenuColor;
    logo;
    constructor(
        private navController: NavController,
        public sharedDataService: SharedDataService,

    ) {
    }

    ngOnInit() {
        this.sharedDataService.headerColor$.subscribe(color => {
            this.headerColor = color;
        });
        this.sharedDataService.menuColor$.subscribe(color => {
            this.menuColor = color;
        });
        this.sharedDataService.subMenuColor$.subscribe(color => {
            this.subMenuColor = color;
        });
        this.sharedDataService.logoPathSubject$.subscribe(logo => {
            this.logo = logo;
        });
    }

    onClose() {
        if (this.closeModal) {
            this.closeModal.emit();
        } else {
            this.navController.back();
        }
    }
}
